import * as React from "react";

/**
 * Ensures children passed to Radix UI primitives (Trigger, Anchor, etc.)
 * always resolve to exactly one React element.
 *
 * Radix uses Slot internally (even without asChild in some cases like
 * SelectTrigger → PopperPrimitive.Anchor) which calls React.Children.only.
 * If children is null, undefined, a Fragment, or multiple elements, it crashes.
 *
 * This utility wraps in a span when needed.
 */
export function ensureSingleChild(children: React.ReactNode): React.ReactElement {
  const arr = React.Children.toArray(children);
  if (arr.length === 1) {
    const el = arr[0];
    if (React.isValidElement(el) && el.type !== React.Fragment) {
      return el;
    }
  }
  // Wrap in span: handles 0 children, 2+ children, Fragment, or non-element nodes
  return React.createElement(
    "span",
    { className: "inline-flex items-center gap-2" },
    children,
  );
}
